<template>
  <section class="section-login mt-56 container">
    <div>
      <div class="section-login-inner">
        <b-img
          :src="`${publicPath}assets/images/trebel_logo.png`"
          class="trebel-logo"
          alt="Trebel"
        ></b-img>
        <form @submit.prevent="login">
          <h5
            v-if="user.connectMethod === 'email'"
            class="verify-account-title"
          >
            {{ $t("webDeleteAccount") }}
          </h5>
          <h5 v-else class="verify-account-title">
            {{ $t("verifyAccount") }}
          </h5>
          <ui-facebook
            v-if="user && user.connectMethod === 'facebook'"
            :action="loginFacebook"
            :key="accountNotMatch"
          ></ui-facebook>
          <ui-google
            v-if="user && user.connectMethod === 'google'"
            :action="onGoogleSignInClick"
          >
          </ui-google>
          <ui-apple
            v-if="user && user.connectMethod === 'apple'"
            :appleAccountNotMatch="appleAccountNotMatch"
            :connectValue="user.connectValue"
          ></ui-apple>
          <ui-discord
            v-if="user && user.connectMethod === 'discord'"
            :onlyIcon="false"
            :action="initDiscordAuth"
          ></ui-discord>
          <ui-email
            v-if="user && user.connectMethod === 'email'"
            :userEmail="user.connectValue"
            :userPass="user.password"
          ></ui-email>
        </form>
      </div>
    </div>
    <snackbar :showSnackbar="accountNotMatch"></snackbar>
  </section>
</template>
<script>
import axios from "axios";
import helpers from "@/helpers";
import UiFacebook from "@/components/Ui/UiFacebook";
import Snackbar from "@/components/Snackbar.vue";
import UiGoogle from "@/components/Ui/UiGoogle.vue";
import UiEmail from "@/components/Ui/UiEmail.vue";
import UiApple from "@/components/Ui/UiApple.vue";
import UiDiscord from "../components/Ui/UiDiscord.vue";
export default {
  data() {
    return {
      user: "",
      accountNotMatch: false
    };
  },
  components: {
    UiFacebook,
    UiGoogle,
    Snackbar,
    UiEmail,
    UiApple,
    UiDiscord
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    appleAccountNotMatch(notMatch) {
      this.accountNotMatch = notMatch;
    },
    async getUserInfo() {
      if (!this.$route.query.token) return;
      localStorage.setItem("token", this.$route.query.token);
      const decodeToken = helpers.parseJwt(this.$route.query.token);
      try {
        const data = await axios.get(
          `${process.env.VUE_APP_HOST_WS}/api/users/info`,
          {
            headers: {
              Authorization: `Bearer ${this.$route.query.token}`
            }
          }
        );
        if (data && data.data && data.data.result && data.data.result.user) {
          this.user = data.data.result.user;
          this.user.userId = decodeToken.userId;
          localStorage.setItem("userInfo", JSON.stringify(this.user));
          if (this.user.connectMethod === "facebook") {
            this.initFacebookLogin();
          }
          if (this.user.connectMethod === "google") {
            this.loadGapiAndAfterwardsInitAuth();
          }
        }
      } catch (error) {
        window.location = "https://home.trebel.io";
      }
    },
    loadGapiAndAfterwardsInitAuth() {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.googleReady = true;
        this.initGoogleLogin(); // only call when script is ready
      };

      document.head.appendChild(script);
    },
    initGoogleLogin() {
      if (!window.google || !window.google.accounts.id) {
        console.error("Google Identity Services not loaded yet.");
        return;
      }

      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: response => {
          const credential = response.credential;

          if (!credential) {
            console.error("No credential received.");
            return;
          }

          const parsedToken = helpers.parseJwt(credential);
          const userID = parsedToken.sub;

          if (userID === this.user.connectValue) {
            this.accountNotMatch = false;
            this.$router
              .push({
                name: "DeleteAccount",
                query: this.$route.query
              })
              .catch(() => {});
          } else {
            this.accountNotMatch = true;
          }
        }
      });
    },

    onGoogleSignInClick() {
      window.google.accounts.id.prompt(); // shows the One Tap prompt
    },
    initFacebookLogin() {
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: process.env.VUE_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: "v17.0"
        });

        window.FB.AppEvents.logPageView();
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },
    loginFacebook() {
      window.FB.login(
        response => {
          if (response.authResponse && response.status === "connected") {
            if (response.authResponse.userID === this.user.connectValue) {
              this.$router
                .push({
                  name: "DeleteAccount",
                  query: this.$route.query
                })
                .catch(() => {});
            } else {
              window.FB.logout(() => {
                this.accountNotMatch = false;
              });
              this.accountNotMatch = true;
            }
          }
        },
        {
          scope: "email",
          auth_type: "rerequest"
        }
      );
    },
    initDiscordAuth() {
      localStorage.setItem("discordVerify", true);
      const uri = encodeURIComponent(process.env.VUE_APP_DISCORD_REDITRECT_URI);
      const discordAuthUri = `https://discord.com/api/oauth2/authorize?client_id=${process.env.VUE_APP_DISCORD_CLIENT_ID}&response_type=code&redirect_uri=${uri}&scope=identify+email`;

      window.location.href = discordAuthUri;
    }
  }
};
</script>
<style scoped></style>
